export default {
	CREATE: 'create',
	DRAG: 'drag',
	ERASE: 'erase',
	FLIP: 'flip',
	FOCUS: 'focus',
	GESTURE: 'gesture',
	NONE: 'none',
	RESIZE: 'resize',
	ROTATE: 'rotate',
	STYLE: 'style',
	WRITE: 'write',
}
